/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
import { Popover, Box, Typography } from '@mui/material';
import { Call, CallDisconnectStatus } from '../typings';
import CallChip from './CallChip';

interface MoreCallsPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  calls: Array<Call & { callStartTime?: number }>;
  activeCallId?: string | null;
  onSelect: (call: Call) => void;
  onMinimize?: (call: Call) => void;
  onCloseChip?: (call: Call) => void;
  onDisconnect: (status: CallDisconnectStatus, call: Call, removeWithoutDelay?: boolean) => void;
  onAcceptStateChange: (call: Call, state: any) => void;
  onRequestAccept: (call: Call, switchCall?: boolean) => void;
}

const MoreCallsPopover: React.FC<MoreCallsPopoverProps> = ({
  anchorEl,
  onClose,
  calls,
  activeCallId,
  onSelect,
  onMinimize,
  onCloseChip,
  onDisconnect,
  onAcceptStateChange,
  onRequestAccept,
}) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          mt: 1,
          borderRadius: '12px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
          width: 'min-content',
        },
      }}
    >
      <Box
        css={css`
          padding: 8px;
          width: max-content;
          max-height: 400px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          gap: 8px;
        `}
      >
        {calls.map((call, index) => (
          <CallChip
            key={call.tempCallId || call.callId}
            call={call}
            isActive={activeCallId === call.callId}
            onSelect={onSelect}
            onMinimize={onMinimize}
            onCloseChip={onCloseChip || (() => {})}
            onDisconnect={onDisconnect}
            onRequestAccept={onRequestAccept}
            onAcceptStateChange={(call, state) => onAcceptStateChange(call, state)}
            isAnyCallActive={!!activeCallId}
          />
        ))}
      </Box>
    </Popover>
  );
};

export default MoreCallsPopover;
